/**
 * Accepts the no swipe boolean and returns the button card text
 *
 * @param noSwipe - Boolean indicating if this is a no-swipe provider
 * @returns Appropriate button card text based on provider type
 */
export const getButtonCardText = (noSwipe: boolean): string => {
  return noSwipe
    ? 'Get important information on how to use your Sidecar Health benefits at this pre-checked provider'
    : 'Learn about their services, providers, locations, and contact information.'
}
